module.exports = __webpack_public_path__ + "static/media/BOL.25b52856.svg";